import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CryptoJsService } from '../services/crypto-js.service';

@Injectable({
  providedIn: 'root'
})
export class CAOGuardGuard implements CanActivateChild {
  constructor(
    private router: Router,
    private cryptoJsService: CryptoJsService
  ) { }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const isCAOLogin = loginDetails.get('isCAO') ? loginDetails.get('isCAO') : null;

    if (isCAOLogin === '1') {
      return true;
    } else {
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }

  
}
